import { ChartEvent, ChartOptions, LegendElement, LegendItem } from 'chart.js';
import { chartOnClickBehavior, setCursorStyle } from 'src/app/common/chartUtils';

export enum YAxisType {
  value = 'value',
  percent = 'percent',
}

export const newDefaultChartOptions = () =>
  ({
    maintainAspectRatio: false, // <-- Maintain the original canvas aspect ratio (width / height) when resizing. Setting to false to will be kept in the div container ratio.
    responsive: true, // <-- Resizes the chart canvas when its container does
    plugins: {
      tooltip: {
        callbacks: {
          // Populated in TS code
        },
      },
      legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,
          boxWidth: 6,
          boxHeight: 6,
          textAlign: 'center',
          font: {
            size: 14,
            family: 'Inter',
            weight: '400',
          },
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onHover(e: ChartEvent, legendItem: LegendItem, legend: LegendElement<'line'>) {
          setCursorStyle(e?.native?.target as HTMLElement, 'pointer');
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onLeave(e: ChartEvent, legendItem: LegendItem, legend: LegendElement<'line'>) {
          setCursorStyle(e?.native?.target as HTMLElement, 'auto');
        },

        onClick(e: ChartEvent, legendItem: LegendItem, legend: LegendElement<'line'>) {
          if (legendItem.datasetIndex === undefined) return;
          chartOnClickBehavior(legend.chart, legendItem.datasetIndex);
        },
      },
    },
    scales: {
      x: {
        grid: {
          drawTicks: false,
        },
        type: 'time',
        time: {
          unit: 'month',
          displayFormats: { month: 'MMM yyyy' },
          tooltipFormat: 'dd MMM, yyyy',
        },
      },
      y: {
        type: 'linear',
        grid: {
          drawTicks: false,
        },
        ticks: {
          font: {
            size: 10,
          },
        },
      },
    },
  }) as ChartOptions<'line'>;
